<template>
  <div class="motivos-rechazo">
    <h1>Motivos de Rechazo</h1>
    
    <!-- Tabla de motivos de rechazo -->
    <div class="d-flex justify-content-end mb-3">
      <button @click="addMotivoRechazo" class="btn btn-primary">
        <i class="bi bi-plus-circle me-1"></i> Nuevo Motivo de Rechazo
      </button>
    </div>
    
    <div class="alert alert-info" v-if="loading">Cargando motivos de rechazo...</div>
    <div class="alert alert-danger" v-if="error">{{ error }}</div>
    
    <div class="table-responsive" v-if="!loading && !error && motivosRechazo && motivosRechazo.length > 0">
      <table class="table table-striped table-hover">
        <thead class="table-dark">
          <tr>
            <th @click="sort('IdMotivoRechazo')" class="sortable">ID <i :class="sortIcon('IdMotivoRechazo')"></i></th>
            <th @click="sort('Descripcion')" class="sortable">Descripciu00f3n <i :class="sortIcon('Descripcion')"></i></th>
            <th @click="sort('FechaCreacion')" class="sortable">Fecha Creaciu00f3n <i :class="sortIcon('FechaCreacion')"></i></th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="motivo in paginatedData" :key="motivo.IdMotivoRechazo">
            <td>{{ motivo.IdMotivoRechazo }}</td>
            <td>{{ motivo.Descripcion }}</td>
            <td>{{ format(new Date(motivo.FechaCreacion), 'dd/MM/yyyy HH:mm') }}</td>
            <td>
              <div class="btn-group">
                <router-link :to="`/motivos-rechazo/edit/${motivo.IdMotivoRechazo}`" class="btn btn-sm btn-warning me-1">
                  <i class="bi bi-pencil"></i> Editar
                </router-link>
                <button @click="confirmDelete(motivo.IdMotivoRechazo)" class="btn btn-sm btn-danger">
                  <i class="bi bi-trash"></i> Borrar
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    
    <div class="alert alert-info" v-if="!loading && !error && (!motivosRechazo || motivosRechazo.length === 0)">
      No hay motivos de rechazo registrados. Haga clic en 'Nuevo Motivo de Rechazo' para agregar uno.
    </div>

    <div class="mt-4">
      <router-link to="/" class="btn btn-secondary">
        <i class="bi bi-arrow-left me-1"></i> Volver al Menú
      </router-link>
    </div>
  </div>
</template>

<script>
import { useAccessControl } from '@/composables/useAccessControl'
import MotivosRechazoViewController from '../controllers/MotivosRechazoViewController';
import { format } from 'date-fns';

export default {
  name: 'MotivosRechazoView',
  components: {},
  setup() {
    const { requiresAuth, requiresMenuPermission } = useAccessControl({
      requiresAuth: true,
      requiresMenuPermission: true
    })

    return {
      requiresAuth,
      requiresMenuPermission
    }
  },
  data() {
    return {
      controller: new MotivosRechazoViewController()
    };
  },
  computed: {
    motivosRechazo() {
      return this.controller.motivosRechazo;
    },
    loading() {
      return this.controller.loading;
    },
    error() {
      return this.controller.error;
    },
    paginatedData() {
      return this.controller.paginatedData;
    }
  },
  created() {
    this.controller.initialize();
  },
  methods: {
    format,
    async fetchMotivosRechazo() {
      await this.controller.loadMotivosRechazo();
    },
    addMotivoRechazo() {
      this.$router.push('/motivos-rechazo/add');
    },
    editMotivoRechazo(motivoRechazo) {
      this.$router.push(`/motivos-rechazo/edit/${motivoRechazo.IdMotivoRechazo}`);
    },
    confirmDelete(motivoRechazoId) {
      this.$alert.confirm(
        '¿Está seguro que desea eliminar este motivo de rechazo?',
        'Confirmar eliminación',
        { icon: 'warning' }
      ).then(async (result) => {
        if (result.isConfirmed) {
          const deleteResult = await this.controller.deleteMotivoRechazo(motivoRechazoId);
          
          if (deleteResult.success) {
            this.$alert.success(deleteResult.message);
            await this.controller.reloadMotivosRechazo();
          } else {
            this.$alert.error(deleteResult.message);
          }
        }
      });
    },
    sort(field) {
      this.controller.sort(field);
    },
    sortIcon(field) {
      return this.controller.sortIcon(field);
    }
  }
}
</script>
